import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.4998 6C9.37275 6.00002 6.13287 7.7908 3.8616 11.6063C3.71736 11.8486 3.71736 12.1515 3.8616 12.3939C6.13287 16.2093 9.37274 18 12.4998 18C15.6268 18 18.8666 16.2092 21.1379 12.3937C21.2822 12.1514 21.2822 11.8485 21.1379 11.6062C18.8666 7.7907 15.6268 5.99998 12.4998 6ZM12.4998 4C16.4515 3.99997 20.2903 6.27232 22.8565 10.5831C23.376 11.4558 23.376 12.5441 22.8565 13.4168C20.2903 17.7276 16.4515 20 12.4998 20C8.54805 20 4.70919 17.7277 2.14305 13.4169C1.62354 12.5442 1.62354 11.4559 2.14305 10.5832C4.70919 6.27243 8.54804 4.00003 12.4998 4ZM12.4998 10C11.3952 10 10.4998 10.8954 10.4998 12C10.4998 13.1046 11.3952 14 12.4998 14C13.6043 14 14.4998 13.1046 14.4998 12C14.4998 10.8954 13.6043 10 12.4998 10ZM8.49976 12C8.49976 9.79086 10.2906 8 12.4998 8C14.7089 8 16.4998 9.79086 16.4998 12C16.4998 14.2091 14.7089 16 12.4998 16C10.2906 16 8.49976 14.2091 8.49976 12Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }